// extracted by mini-css-extract-plugin
export default {"protected":"jBgBuf1itaif0Gy04QVi","menu":"ai76pGEs7JtCdDJWjOL4","icon-open":"D8xica71_1YvnhcNWvim","icon-close":"SXZzF3cw9UIGvD1NK9fU"};